import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";

interface KeyMappingProps {
  label: string;
  keyMapping: string;
  onKeyChange: (label: string, key: string) => void;
  listeningKey: string | null;
  setListeningKey: (key: string | null) => void;
  openKeyModal: boolean;
}

export default function KeyMapping({
  label,
  keyMapping,
  onKeyChange,
  listeningKey,
  setListeningKey,
  openKeyModal,
}: KeyMappingProps) {
  const listening = listeningKey === label;

  const handleKeyPress = (event: KeyboardEvent) => {
    if (listening) {
      event.preventDefault();
      onKeyChange(label, event.key.toUpperCase());
      setListeningKey(null);
    }
  };
  const handleClick = () => {
    if (listening) {
      setListeningKey(null);
    } else {
      setListeningKey(label);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [listening]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 1,
      }}
    >
      {/* <Typography
        variant="body1"
        sx={{ color: "var(--text-color)", marginRight: "10px" }}
      >
        {label}
      </Typography> */}
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{
          bgcolor: listening
            ? "var(--key-mapping-on)"
            : "var( --key-mapping-off)",
          "&:hover": {
            bgcolor: "var(--button-hover-bg)",
          },
        }}
      >
        {keyMapping}
      </Button>
    </Box>
  );
}
